import * as React from "react";

import {Select, Form} from "antd";
const Option = Select.Option;

interface IProps {
  getFieldDecorator: any;
}

export default (props: IProps) => {
  const {getFieldDecorator} = props;

  return(
    <Form.Item label='Year'>
      {getFieldDecorator('year', {
        initialValue: -1
      })(
        <Select style={{width: 200}} placeholder='Select year'>
          <Option value={-1}>Not selected</Option>
          <Option value={2018}>2018</Option>
          <Option value={2017}>2017</Option>
          <Option value={2016}>2016</Option>
          <Option value={2015}>2015</Option>
          <Option value={2014}>2014</Option>
          <Option value={2013}>2013</Option>
          <Option value={2011}>2011</Option>
          <Option value={2010}>2010</Option>
        </Select>
      )}

    </Form.Item>
  )
}